import View from './Accounts';
import enhancer from './Accounts.enhancer';

const Accounts = enhancer(View);

export default Accounts;
